import React, {useEffect, useState} from "react";
import {Button} from "primereact/button";
import classes from "./SparqlQueries.module.css";
import Aux from "../../../hoc/Auxiliary";
import SparqlQueryPythonScript from "./Query/SparqlQueryPythonScript";
import {
    checkAllQueries,
    checkQuery,
    compareArrays,
    deleteEmptyParameters,
    generateNewQueryWithID
} from "../../../api/utils/SparqlQueries";
import {useNavigate} from "react-router-dom";
import {saveSparqlQueries} from "../../../api/dataCollection/sparql-queries-service";
import {updateProperty} from "../../../api/utils/conditions-utils";
import {InputText} from "primereact/inputtext";
import {TabPanel, TabView} from "primereact/tabview";
import {Card} from "primereact/card";


const SparqlQueries = ({queriesList, dataCollection, initialQueries}) => {
    const [queries, setQueries] = useState(queriesList)
    const [addButtonDisabled, setAddButtonDisabled] = useState(true);
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [deletedQueriesId, setDeletedQueriesId] = useState([]);
    const [filter, setFilter] = useState("");
    const [filteredQueries, setFilteredQueries] = useState([])
    const [activeTab, setActiveTab] = useState(0)

    const navigate = useNavigate();

    const save = () => {
        setIsLoading(true);
        setAddButtonDisabled(true)
        const nonEmpty = queries.filter(q => checkQuery(q, queries) === '')
            .map(q => {
                if (q.queryId < 0)
                    delete q.queryId
                return q
            });
        const nqs = updateProperty(nonEmpty.length > 0, [...deleteEmptyParameters(nonEmpty)], [])
        saveSparqlQueries(dataCollection, nqs, deletedQueriesId)
            .then((data) => {
                setIsLoading(false);
                setAddButtonDisabled(true);
                if (data.status === 200 && data.content.length > 0) {
                    let names = data.content.map(e => e.queryName);
                    setQueries([...queries.filter(e => names.includes(e.name))])
                } else {
                    navigate("/data_collections")
                }
            })
    }

    const getNewSparqlId = () => {
        const negativeIds = queries.map(q => q.queryId)
            .filter(id => typeof id === "number" && !isNaN(id) && id < 0);

        if (negativeIds.length === 0) return -1;

        return Math.min(...negativeIds) - 1;
    };

    const deleteCurrentQuery = (queryId) => {
        setDeletedQueriesId([...deletedQueriesId, queryId].filter(e => e > 0))
        if (queries.length === 1) {
            setQueries(generateNewQueryWithID(getNewSparqlId()))
        } else {
            const nq = [...queries.filter((e) => e.queryId !== queryId)];
            setQueries(nq)
            setSaveButtonDisabled(isSaveDisable(nq))
        }
    }

    const addNewQuery = () => {
        const nq = generateNewQueryWithID(getNewSparqlId());
        setQueries([...queries, ...nq])
    }

    const emptyQueries = (qList) => {
        return qList.length === 1 && qList[0].name === "" && qList[0].content === ""
    }

    const isSaveDisable = (qList) => {
        return (checkAllQueries(qList).length > 0 && !emptyQueries(qList)) || compareArrays(qList, initialQueries);

    }

    const isBtnAddDisabled = (queriesList) => {
        if (queriesList?.length === 0 || (queriesList?.length === 1 && queriesList[0].queryId === undefined)) return false;

        return queriesList?.length > 1 &&
            queriesList.some(query =>
                query.queryId !== undefined &&
                checkQuery(query, queriesList).length > 0
            );
    }

    function getFilteredQueries() {
        return queries.filter((query) =>
            query.name?.toLowerCase().includes(filter.trim().toLowerCase())
        );
    }

    useEffect(() => {
        setAddButtonDisabled(isBtnAddDisabled(queries));
        setSaveButtonDisabled(isSaveDisable(queries));
        setFilteredQueries(getFilteredQueries());
    }, [filter, queries]);

    function mergeNewQueryWithAllQueries(selectQuery) {
        setQueries([...queries.map(q => {
            if (q.queryId === selectQuery.queryId) return selectQuery
            return q
        })])
    }

    return (
        <Aux>
            <TabView activeIndex={activeTab} onTabChange={(e) => {
                setFilter("");
                setActiveTab(e.index)
            }}>
                <TabPanel header="SparQL Queries" className={"custom-tab-panel"}>
                    <div className="mb-3">
                        <InputText
                            value={filter}
                            onChange={(e) => setFilter(e.target.value)}
                            placeholder="Filter queries..."
                        />
                    </div>
                    {filteredQueries.length > 0 ? (
                        filteredQueries.filter(querie => querie.queryType === "SparQLQuery").map((selectQuery, i) => (
                            <div className="mb-3" key={`cat-${i + 1}`}>
                                <SparqlQueryPythonScript
                                    identifier={i}
                                    error={checkQuery(selectQuery, queries)}
                                    key={`sparql-${selectQuery.queryId}`}
                                    currentQuery={selectQuery}
                                    updateCurrentQuery={mergeNewQueryWithAllQueries}
                                    deleteCurrentQuery={() => deleteCurrentQuery(selectQuery.queryId)}
                                    readOnly={selectQuery["queryId"] >= 0}
                                />
                            </div>
                        ))
                    ) : (
                        <Card role="region">No query is defined !</Card>
                    )}
                </TabPanel>
                <TabPanel header="Python Scripts" className={"custom-tab-panel"}>
                    <div className="mb-3">
                        <InputText
                            value={filter}
                            onChange={(e) => setFilter(e.target.value)}
                            placeholder="Filter queries..."
                        />
                    </div>
                    {filteredQueries.length > 0 ? (
                        filteredQueries.filter(querie => querie.queryType === "PythonScript").map((selectQuery, i) => (
                            <div className="mb-3" key={`cat-${i + 1}`}>
                                <SparqlQueryPythonScript
                                    error={checkQuery(selectQuery, queries)}
                                    key={`sparql-${selectQuery.queryId}`}
                                    currentQuery={selectQuery}
                                    updateCurrentQuery={mergeNewQueryWithAllQueries}
                                    deleteCurrentQuery={() => deleteCurrentQuery(selectQuery.queryId)}
                                    readOnly={selectQuery["queryId"] >= 0}
                                />
                            </div>
                        ))
                    ) : (
                        <Card role="region">No python script is defined !</Card>
                    )}
                </TabPanel>
            </TabView>
            <div>
                <div className="flex">
                    <div className="col-12">
                        <div className="grid">
                            <div className="col-9"/>

                            <div className="flex col-3 justify-content-end pr-0">
                                {activeTab === 0 &&
                                    <Button
                                        type="button"
                                        className={classes.actionBtn}
                                        label="Add Query"
                                        onClick={addNewQuery}
                                        disabled={addButtonDisabled}
                                    />}
                                <Button
                                    type="button"
                                    className={`${classes.actionBtn} ml-3`}
                                    label={queries.length > 1 ? "Save Queries" : "Save Query"}
                                    onClick={save}
                                    disabled={saveButtonDisabled}
                                    loading={isLoading}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Aux>
    );
};

export default SparqlQueries;
